import _toConsumableArray from "D:/coding/pmv5-fe/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
import pageMixin from "../mixins/page";
import Axios from "axios";
import UserInfoModal from "./UserInfoModal";
import UpdateGroupModal from "./UpdateGroupModal.vue";
import UpdateProductsModal from "./UpdateProductsModal.vue";
import TableDetailModal from "./TableDetailModal";
import ResetPassModal from "./ResetPassModal";
export default {
  name: "user-list",
  mixins: [pageMixin],
  components: {
    UserInfoModal: UserInfoModal,
    UpdateGroupModal: UpdateGroupModal,
    UpdateProductsModal: UpdateProductsModal,
    TableDetailModal: TableDetailModal,
    ResetPassModal: ResetPassModal
  },
  data: function data() {
    return {
      searchText: "",
      searchStatus: 0,
      sortKey: '-id',
      roleList: [{
        label: '全部',
        value: '全部'
      }],
      selectedRoleId: '全部',
      columns: [{
        type: "selection",
        width: 60,
        align: "center"
      }, {
        title: "用户名",
        sortable: true,
        key: "username"
      }, {
        title: "真实姓名",
        key: "realname",
        sortable: true
      }, {
        title: "帐号状态",
        key: "is_active_text",
        sortable: true
      }, {
        title: "邮箱",
        sortable: true,
        key: "email"
      }, {
        title: "单位",
        sortable: true,
        key: "employer"
      }, {
        title: "岗位",
        sortable: true,
        key: "job_title"
      }, {
        title: "权限",
        sortable: false,
        key: "group_name"
      },
      // 去掉产品范围字段
      // {
      //     title: "产品范围",
      //     sortable: false,
      //     key: "product-commodities",
      //     render(h, params){
      //         return h('span', params.row['product-commodities'].length > 0 ? JSON.stringify(params.row['product-commodities']) : "")
      //     }
      // }, 
      {
        title: "最大试用点数",
        key: "max_point_num"
      }, {
        title: "最大试用天数",
        key: "max_trial_days"
      }, {
        title: "最后登录时间",
        sortable: true,
        key: "last_login"
      }, {
        title: "创建时间",
        key: "date_joined",
        sortable: true
      }, {
        title: "操作",
        align: 'center',
        width: '100',
        slot: 'btns'
      }],
      data: [],
      selection: [],
      selectUser: null,
      showAddEditUser: false,
      showUpdateModal: false,
      showProductsModal: false,
      // 用户详情
      showTableDetail: false,
      tableDetail: {},
      tableDetailColumns: [{
        title: "ID",
        key: "id"
      }, {
        title: "用户名",
        key: "username"
      }, {
        title: "真实姓名",
        key: "realname"
      }, {
        title: "用户角色",
        key: "group",
        render: function render(h, params) {
          return h('span', params.row.group ? params.row.group.name : "");
        }
      }, {
        title: "帐号状态",
        key: "is_active_text"
      }, {
        title: "邮箱",
        sortable: true,
        key: "email"
      }, {
        title: "手机号码",
        key: "mobile"
      }, {
        title: "单位",
        key: "employer"
      }, {
        title: "岗位",
        sortable: true,
        key: "job_title"
      }, {
        title: "权限",
        sortable: false,
        key: "group_name"
      },
      // 去掉产品范围字段
      // {
      //     title: "产品范围",
      //     key: "product-commodities",
      //     render(h, params){
      //         return h('span', params.row['product-commodities'].length > 0 ? JSON.stringify(params.row['product-commodities']) : "")
      //     }
      // }, 
      {
        title: "最大试用点数",
        key: "max_point_num"
      }, {
        title: "最大试用天数",
        key: "max_trial_days"
      }, {
        title: "最后登录时间",
        key: "last_login"
      }, {
        title: "创建时间",
        key: "date_joined"
      }],
      showResetPass: false,
      toResetPassId: '',
      showActiveUser: false
    };
  },
  created: function created() {
    this.getRoleList();
    this.refresh();
  },
  methods: {
    changeStatus: function changeStatus(val) {
      this.refresh();
    },
    refresh: function refresh() {
      var _this = this;
      this.selection.splice(0);
      var data = {
        name: this.searchText,
        order_by: this.sortKey,
        page: this.currentPage,
        per_page: this.pageSize,
        group: this.selectedRoleId
      };
      if (data.group === '全部') {
        data.group = '';
      }
      if (this.searchStatus === 0) {
        data.is_active = false;
      }
      var onFinish = this.setLoading.bind(this, false);
      this.setLoading(true);
      Axios.get("users/", {
        params: data
      }).then(function (resp) {
        var users = resp.data.users;
        users.forEach(function (u) {
          u.is_active_text = u.is_active ? "已激活" : "未激活";
          u.group_name = u.group.name;
        });
        _this.data = users;
        _this.total = resp.data.page_info.count; //Todo : 等待后端接口吧count信息返回再修改为this.setPageVars(resp.data.page_info)
      }).then(onFinish, onFinish);
    },
    activate: function activate() {
      var _this2 = this;
      var user = this.selection[0];
      var id = user.id;
      if (user.is_active) {
        // 直接禁用
        Axios.post("users/".concat(id, "/activate/")).then(function () {
          return _this2.refresh();
        });
        return false;
      }

      // 选择角色
      this.showActiveUser = true;
    },
    editUser: function editUser() {
      var user = this.selection.filter(function (u) {
        return u.is_active;
      })[0];
      this.selectUser = user;
      this.showAddEditUser = true;
    },
    deleteUser: function deleteUser() {
      var _this3 = this;
      this.$Modal.confirm({
        title: '是否确认删除该用户？',
        content: '',
        onOk: function onOk() {
          var id = _this3.selection[0].id;
          Axios.delete("users/".concat(id, "/")).then(function () {
            return _this3.refresh();
          });
        },
        onCancel: function onCancel() {}
      });
    },
    resetPass: function resetPass() {
      this.showResetPass = true;
      this.toResetPassId = this.selection[0].id;
    },
    updateGroup: function updateGroup() {
      var user = this.selection.filter(function (u) {
        return u.is_active;
      })[0];
      this.selectUser = user;
      this.showUpdateModal = true;
    },
    updateProducts: function updateProducts() {
      var user = this.selection.filter(function (u) {
        return u.is_active;
      })[0];
      this.selectUser = user;
      this.showProductsModal = true;
    },
    onModalClose: function onModalClose(val) {
      val && this.refresh();
    },
    onSelectionChange: function onSelectionChange(rows) {
      var _this$selection;
      this.selection.length = 0;
      (_this$selection = this.selection).push.apply(_this$selection, _toConsumableArray(rows));
    },
    viewDetails: function viewDetails(rows) {
      // let detail = encodeURI(encodeURI(JSON.stringify(rows)))
      // window.open('tableDetail.html?tableDetail=' + detail)
      this.tableDetail = rows;
      this.showTableDetail = true;
    },
    getRoleList: function getRoleList() {
      var _this4 = this;
      this.roleList.splice(1);
      Axios.get("users/groups/", {
        params: {
          order_by: 'name'
        }
      }).then(function (resp) {
        var groups = resp.data.groups;
        groups = groups || [];
        groups.map(function (item) {
          _this4.roleList.push({
            value: item.id,
            label: item.name
          });
        });
      });
    },
    changeRole: function changeRole() {
      this.refresh();
    }
  }
};